/* eslint-disable no-nested-ternary */
/* eslint-disable no-alert */
import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Table01 from "./Table01";
import Table02 from "./Table02";
import Table03 from "./Table03";
import Table04 from "./Table04";
import Table05 from "./Table05";
import Table06 from "./Table06";
import Table07 from "./Table07";
import Table08 from "./Table08";
import Table09 from "./Table09";
import FolderDialog from "../../static/FolderDialog";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
  },
  container: {
    marginTop: 14,
  },
  cells: {
    border: "solid 1px #B6B3B3",
    backgroundColor: "#fff",
  },
  headCells: {
    border: "solid 1px #B6B3B3",
    backgroundColor: "#E4ECFF",
  },
  t1: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#292929",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  t2: {
    fontSize: 14,
    color: "#292929",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  tKey: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#292929",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  tValue: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#0A369D",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  tError: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#FF1339",
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  iconEye: {
    fontSize: 28,
    cursor: "pointer",
    color: "#009693",
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  iconArrow: {
    fontSize: 28,
    [theme.breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
}));

export default function OrganizationDocuments({ data }) {
  const classes = useStyles();

  const [activeFolder, setActiveFolder] = React.useState(null);
  return (
    <div className={classes.root}>
      <FolderDialog folder={activeFolder} setActiveFolder={setActiveFolder} />
      <Table01
        classes={classes}
        data={data.license || {}}
        setActiveFolder={setActiveFolder}
      />
      <Table02
        classes={classes}
        data={data.national || {}}
        setActiveFolder={setActiveFolder}
      />
      <Table03
        classes={classes}
        data={data.registery || {}}
        setActiveFolder={setActiveFolder}
      />
      <Table04
        classes={classes}
        data={data.official_change_declarements || []}
        setActiveFolder={setActiveFolder}
      />
      <Table05
        classes={classes}
        data={data.statute_docs || {}}
        setActiveFolder={setActiveFolder}
      />
      <Table06
        classes={classes}
        data={data.association_reports || {}}
        setActiveFolder={setActiveFolder}
      />
      <Table07
        classes={classes}
        data={data.financial_docs || []}
        setActiveFolder={setActiveFolder}
      />
      <Table08
        classes={classes}
        data={data.annual_accounting || []}
        setActiveFolder={setActiveFolder}
      />
      <Table09
        classes={classes}
        data={data.other_files || []}
        setActiveFolder={setActiveFolder}
      />
    </div>
  );
}
